import OutputCardView from './OutputCardView.html';
import './outputCard.scss';
import { ConditionViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/ConditionViewModel';
class OutputCard {
    static $inject = ['$translate', 'SavingService', '$rootScope'];
    constructor($translate, SavingService, $rootScope) {
        'ngInject';
        this.$translate = $translate;
        this.SavingService = SavingService;
        this.$rootScope = $rootScope;
    }
    $onInit() {
        if (!this.output.conditions) {
            this.output.conditions = [];
            this.createCondition();
        }
    }
    $onEdit($node) {
        this.onEdit({ $node });
    }
    createCondition() {
        const condition = new ConditionViewModel();
        this.output.conditions = this.output.conditions.concat(condition);
        this.onChange();
    }
    removeOutput() {
        this.onRemove();
    }
    async changeOutputState($data) {
        this.output.typeOfStateId = $data.newTypeOfStateId ?? this.output.typeOfStateId;
        $data.output = this.output;
        await this.outputChanged({ $data });
    }
    addNewState($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewState({ $data });
    }
    addNewSurvey($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewSurvey({ $data });
    }
    async removeCondition(index) {
        if (this.output.conditions.length == 1) {
            this.onRemove();
        }
        else {
            await this.onRemoveCondition({ $data: index });
        }
    }
}
OutputCard.$inject = ['$translate', 'SavingService', '$rootScope'];
export const OutputCardComponent = {
    controller: OutputCard,
    controllerAs: '$ctrl',
    template: OutputCardView,
    bindings: {
        onChange: '&',
        onEdit: '&?',
        onRemove: '&',
        onRemoveCondition: '&',
        outputChanged: '&',
        index: '<',
        output: '<',
        states: '<',
        state: '<',
        application: '<?',
        onAddNewState: '&?',
        onAddNewSurvey: '&?',
        showSwitchSurvey: '<',
    },
};
